export default (function (e) {
  return e && "string" == typeof e && decodeURIComponent(e).replace(/\+/g, "%20");
});